import { Button } from "react-bootstrap";

import { twMerge } from "tailwind-merge";

import { useGetFile } from "../../hooks/useGetFile.tsx";

type ButtonFileProps = {
  path: string;
  label: string | Element;
  isDisabled?: boolean;
  iconClassName?:string | null;
  size?: "sm" | "md" | "lg";
};
export const ButtonFile = ({
  path,
  label,
  isDisabled = false,
  iconClassName = null,
  size = "md",
}: ButtonFileProps) => {
  const fileHandler = async (file: string) => {
    window.open(file);
  };

  const { getFile } = useGetFile({
    enabled: false,
    listFiles: [path],
    keys: ["file", path],
  });

  return (
    <div
      className={twMerge(
        "inline-flex",
        isDisabled && "hover:cursor-not-allowed"
      )}
    >
      <Button
        variant="primary"
        className="btn btn-primary"
        onClick={() => getFile(fileHandler)}
        disabled={isDisabled}
        size={size}
      >
        <div className="d-flex flex-row align-items-center">
          {iconClassName && (
            <i className={`${iconClassName} me-2 text-[#FFFF]`}></i>
          )}
          {label}
        </div>
      </Button>
    </div>
  );
};
